import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { ConfigurationService } from "src/app/configurations/configurationService";
import * as _ from "lodash";
import { VendorOAuthRegistrationService, VendorOAuthRegistrationUserService, VendorService } from "src/app/shared/shared-emails/Integration/api/api";
import {
    Vendor, VendorOAuthRegistration, VendorOAuthRegistrationUser
} from "src/app/shared/shared-emails/Integration/model/models";
import { AccountUserService } from "src/app/service/account.service";
import { AppMainComponent } from "src/app/app.main.component";

@Component({
    selector: "app-smtp-add-edit",
    templateUrl: "./smtp-add-edit.component.html",
    styleUrls: ["./smtp-add-edit.component.scss"],
})
export class SmtpAddEditComponent implements OnChanges {
    @Input() type: any;
    @Input() serverHeader: any;
    @Input() showOthers: any;
    @Input() vendorDetails: any;
    @Input() displayAddEditServer: any;
    @Input() smtpVendorId;
    @Output() onSaveComplete = new EventEmitter();
    @Output() onCancelClicked = new EventEmitter();

    smtpFb: FormGroup;
    windowRef = null;
    constructor(
        public app: AppMainComponent,
        private fb: FormBuilder,
        private service: ConfigurationService,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private vendorRegistrationService: VendorOAuthRegistrationService,
        private accountService: AccountUserService,
        private vendorUserService: VendorOAuthRegistrationUserService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.type && changes.type.currentValue) {
            this.type = changes.type.currentValue;
        }
        if (changes.serverHeader && changes.serverHeader.currentValue) {
            this.serverHeader = changes.serverHeader.currentValue;
        }
        if (changes.showOthers && changes.showOthers.currentValue) {
            this.showOthers = changes.showOthers.currentValue;
        }
        if (changes.vendorDetails && changes.vendorDetails.currentValue) {
            this.vendorDetails = changes.vendorDetails.currentValue;
        }
        if (
            changes.displayAddEditServer &&
            changes.displayAddEditServer.currentValue
        ) {
            this.displayAddEditServer =
                changes.displayAddEditServer.currentValue;
        }
        if (this.type == "ADD") {
            this.initCreateForm();
        } else if (this.type == "EDIT") {
            this.initEditForm();
        }
    }

    initCreateForm() {
        ////console.log(this.vendorDetails);
        this.initForm();
    }

    initEditForm() {
        ////console.log(this.vendorDetails);
        this.initForm();
        this.smtpFb.patchValue({
            ...this.vendorDetails,
        });
    }

    initForm() {
        this.smtpFb = this.fb.group({
            id: [0],
            serverName: ["", Validators.required],
            serverPortOut: [""],
            userName: [""],
            emailId: ["", Validators.required],
            password: ["", Validators.required],
            emailCC: [""],
            emailBCC: [""],
        });

        if (!this.showOthers) {
            let userName = this.smtpFb.get("userName");
            userName.setValidators([Validators.required]);
            userName.updateValueAndValidity();
        }
    }



    save() {
        if (this.type == "ADD") {
            // if(this.serverHeader == "OFFICE SMTP Setting"){
            //     this.configureEmail({id: 1});
            // }else if(this.serverHeader == "GMAIL SMTP Setting"){
            //     this.configureEmail({id: 2});
            // }
            const req = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                name: this.smtpFb.controls.serverName.value,
                description: this.smtpFb.controls.serverName.value,
                /**
                 * vendor id should be based on api
                 * by Name , Outlook, Gmail , Other SMTPs
                 * https://devapp01.liono360.com/LionO360ApplicationIntegrationCoreAPI/LionO360/2.0/API/Vendor
                 */
                vendorId: this.smtpVendorId?.id, //3
                vendor: null,
                serverName: this.smtpFb.controls.serverName.value,
                emailId: this.smtpFb.controls.emailId.value,
                serverPortIn: 0,
                serverPortOut: this.smtpFb.controls.serverPortOut.value,
                userName: this.smtpFb.controls.userName.value ? this.smtpFb.controls.userName.value : this.smtpFb.controls.emailId.value,
                password: this.smtpFb.controls.password.value,
                organizationId: this.app.companyId,
                accountId: 0,
                userId: this.app.user.userId,
                isDefault: false,
                statusId: 1,
                status: null,
                isValid: true,
                validFromDate: new Date().toISOString(),
                validToDate: new Date().toISOString(),
                emailCC: this.smtpFb.controls.emailCC.value,
                emailBCC: this.smtpFb.controls.emailBCC.value,
            };
            this.appMainService.isShowSpinner("loadVendorRegistration");
            this.service.saveVendorSMTPRegistration(req).subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadVendorRegistration");
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "SMTP added successfully...",
                    });
                    this.displayAddEditServer = false;
                    this.onSaveComplete.emit(false);
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadVendorRegistration");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred...",
                    });
                }
            );
        } else {
            const req = _.cloneDeep(this.vendorDetails);
            req.updatedSource = this.app.userIP;
            req.updatedBy = this.app.user.userId;
            req.updatedDate = new Date().toISOString();
            req.serverName = this.smtpFb.controls.serverName.value;
            req.emailId = this.smtpFb.controls.emailId.value;
            req.serverPortOut = this.smtpFb.controls.serverPortOut.value;
            req.userName = this.smtpFb.controls.userName.value;
            req.password = this.smtpFb.controls.password.value;
            req.emailCC = this.smtpFb.controls.emailCC.value;
            req.emailBCC = this.smtpFb.controls.emailBCC.value;
            req.userId = req.userId ? req.userId : this.app.user.userId;

            this.appMainService.isShowSpinner("loadVendorRegistration");
            this.service.updateVendorSMTPRegistration(req).subscribe(
                (res) => {
                    this.appMainService.isHideSpinner("loadVendorRegistration");
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "SMTP updated successfully...",
                    });
                    this.displayAddEditServer = false;
                    this.onSaveComplete.emit(false);
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadVendorRegistration");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: err.error.Message,
                    });
                }
            );
        }
    }

    onDialogClose() {
        this.displayAddEditServer = false;
        this.onCancelClicked.emit(false);
    }
}
